.required {
  color: var(--error);
}

.label {
  padding: 5px 22px;
}

.no-wrap {
  white-space: nowrap;
}
